module.exports = __webpack_public_path__ + "img/addoil.66f3a188.jpg";